/**
 * Directive to show asterisk next to the input label.
 * This is custom directive for md-icon, since it doesn't have asterisk itself.
 */
function AsteriskDirective() {
    return {
        template: '<md-icon md-font-icon="material-icons"><i class="form__asterisk">*</i></md-icon>',
    };
}

AsteriskDirective.$inject = [];

export default AsteriskDirective;



// WEBPACK FOOTER //
// ./src/app/directives/asterisk/asterisk.directive.js